import { ref } from 'vue';

export function useVideoPlayCheck() {
	const canAutoPlay = ref(false);
	const videoCheckDone = ref(false);

	const checkVideoAutoPlayStatus = async videoRef => {
		const video = videoRef.value;
		if (!video) return;

		try {
			video.currentTime = 0;
			await video.play();
			console.log('自动播放成功');
			canAutoPlay.value = true;
		} catch (e) {
			console.log('自动播放失败, 使用图片代替', e);
			canAutoPlay.value = false;
		} finally {
			videoCheckDone.value = true;
		}
	};

	const tryReplay = videoRef => {
		return checkVideoAutoPlayStatus(videoRef);
	};

	return {
		canAutoPlay,
		videoCheckDone,
		checkVideoAutoPlayStatus,
		tryReplay
	};
}
